<template>
  <div>
    <div class="table_th">
      <div style="width:50%">
        {{ $t(`lang.str_amount`) }}
      </div>
      <div style="width:50%">
        {{ $t(`lang.str_odds`) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        <div>{{ bet_amount }}</div>
      </div>
      <div style="width:50%">
        <div>{{ odds }}x</div>
      </div>
    </div>
    <div class="gameImgArea">
      <div class="box box2"  v-for="(item, index) in mapList" :key="index">
        <img :src="require('../../assets/zsdh/' + item + '.png')" alt="" class="deep">
      </div>
    </div>
    <div class="gameImgDetail">
      <div class="box" v-for="(item, subIndex) in mapListDetail" :key="subIndex">
        <img :src="require('../../assets/zsdh/' + item[0] + '.png')" alt="" class="deep">
        <p>x {{item.length}}</p>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">
    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3004",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    mapList:null,
    mapListDetail:null,
    bet_amount:0,
    odds:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3004.vue